<template>
	<c-dialog ref="dialog" width="700px" mode="slide" title="视图列表" enable-flex :button="false" mask-close @close="active = false">
		<m-operate>
			<c-button color="main" prepend-icon="tf-add" @click="$emit('edit')">创建视图</c-button>
		</m-operate>
		<c-table ref="list" height="grow" :paging="false">
			<c-table-column
				type="drag"
				@handle="dragHandle"
			></c-table-column>

			<c-table-column
				label="视图名称"
				width="150"
			>
				<template #default="{data}">
					<div class="flex-center-cross">
						<i class="tf" style="margin-right: 10px; font-size: 16px;" :style="{'color': data.icon && data.icon != 'default' ? `var(--color-${data.icon})` : '#333'}">&#xe63b;</i>
						<span>{{data.view_name}}</span>
					</div>
				</template>
			</c-table-column>
			
			<c-table-column
				label="视图说明"
				name="remark"
				width="345"
				:ellipsis="false"
			></c-table-column>

			<c-table-column
				type="button"
				label="操作"
				width="160"
			>
				<template #default="{data}">
					<c-button @click="$emit('edit', data.id)">编辑</c-button>
					<c-button @click="$emit('edit', data.id, true)">复制</c-button>
					<c-button @click="$emit('delete', data.id)">删除</c-button>
				</template>
			</c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			workType: [String, Number]
		},

		data() {
			return {
				active: false
			}
		},

		methods: {
			open() {
				this.update();
				this.$refs.dialog.open();
				this.active = true;
			},

			update() {
				this.$refs.list.load({
					url: '/sys_user_view/manage_list',
					data: {
						work_type_id: this.workType
					}
				});
			},

			dragHandle() {
				this.request({
					url: '/sys_user_view/sort',
					data: {
						work_type_id: this.workType,
						view_list: this.$refs.list.getData().map((item, index) => {
							return {
								id: item.id,
								sortid: index + 1
							}
						})
					},
					success: () => {
						this.$emit('sort', false);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
